import * as React from "react"

import { cn } from "@/src/helpers"

const Input = React.forwardRef(({ className, type, ...props }, ref) => {
  return (
    (<input
      type={type}
      className={cn(
        "flex h-10 w-full rounded-md border border-[var(--qk-rule)] bg-[var(--qk-paper-3)] px-3 py-2 text-sm text-[var(--qk-ink)] ring-offset-[var(--qk-paper)] file:border-0 file:bg-transparent file:text-sm file:font-medium placeholder:text-[var(--qk-muted)] focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-[var(--qk-ink)] focus-visible:ring-offset-2 disabled:cursor-not-allowed disabled:opacity-50",
        className
      )}
      ref={ref}
      {...props} />)
  );
})
Input.displayName = "Input"

export { Input }
